import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Meeting from './pages/Meeting';
import Landing from './pages/Landing';
import Feedback from './pages/Feedback';

function App() {
  return (
    <Routes>
      {/* Main landing page */}
      <Route path="/" element={<Landing />} />

      {/* Feedback page */}
      <Route path="/feedback/:roomId" element={<Feedback />} />

      {/* Meeting room - directly at /:roomId */}
      <Route path="/:roomId" element={<Meeting />} />
    </Routes>
  );
}

export default App;